const IFRAME_WRAP_CLASS = "ffair-iframe-wrap";
const IFRAME_TAG_NAME = "IFRAME";

const IFRAME_STATUS_NOTICE_TEXT = [
  "iframe is not visible to exhibitors",
  "waiting for approval. domain sent to ffair team",
  "sorry, the link was rejected",
];

const includesIframeStatusNotice = (value: string): boolean => {
  const normalized = value.toLowerCase();
  return IFRAME_STATUS_NOTICE_TEXT.some((noticeText) =>
    normalized.includes(noticeText)
  );
};

const removePersistedNoticeChildren = (wrap: HTMLElement) => {
  Array.from(wrap.childNodes).forEach((child) => {
    if (child.nodeType === Node.TEXT_NODE) {
      if (includesIframeStatusNotice(child.textContent || "")) {
        child.remove();
      }
      return;
    }

    if (!(child instanceof HTMLElement)) return;
    if (child.tagName === IFRAME_TAG_NAME) return;

    if (includesIframeStatusNotice(child.textContent || "")) {
      child.remove();
    }
  });
};

export const stripPersistedIframeStatusNotices = (content: string): string => {
  if (!content.includes(IFRAME_WRAP_CLASS)) {
    return content;
  }

  if (!includesIframeStatusNotice(content)) return content;

  const template = document.createElement("template");
  template.innerHTML = content;
  template.content
    .querySelectorAll<HTMLElement>(`.${IFRAME_WRAP_CLASS}`)
    .forEach(removePersistedNoticeChildren);

  return template.innerHTML;
};

export const stripPersistedExhibitorIframeNotices = (
  content: string
): string => {
  if (!content.includes(IFRAME_WRAP_CLASS)) {
    return content;
  }

  if (!includesIframeStatusNotice(content)) return content;

  const template = document.createElement("template");
  template.innerHTML = content;
  template.content
    .querySelectorAll<HTMLElement>(`.${IFRAME_WRAP_CLASS}`)
    .forEach((wrap) => {
      if (includesIframeStatusNotice(wrap.textContent || "")) {
        wrap.remove();
      }
    });

  return template.innerHTML;
};
